export default {
    messages: {
        en: {
            compareScene: 'Scene',
            result: 'Status',
            PASS: 'Passing',
            PAYMENT: 'Payment',
            ATTENDANCE: 'Attendance'
        },
        zh: {
            compareScene: '比对场景',
            result: '比对结果',
            PASS: '通行',
            PAYMENT: '支付',
            ATTENDANCE: '考勤'
        }
    }
};
